import React from "react";
import { useAppContext } from "../../context/AppContext";
import { ShopTrans } from "../../utils/translations";
import ShopCard from "../utilPages/ShopCard";
// import bgImg from "../../assets/images/bg-3.png";
import bgImg from "../../assets/images/bg-3.png";


export default function About() {
  const { language } = useAppContext();

  return (
    <main className="flex min-h-screen flex-col border-t-[1.5px] border-black mt-5">
        <div className="grid grid-cols-3 h-[55vh] w-10/12 pt-10 mx-auto gap-10">
      <div className="col-span-1 pt-4">
          <img
            src={bgImg}
            alt="Description"
            className="w-full h-full object-cover"
          />
        </div>


        <div className="col-span-2 flex flex-col">
          

        </div>

        
      </div>
    </main>
  );
}
